var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-auto"},[_c('button',{staticClass:"btn light-bg",on:{"click":_vm.logout}},[_vm._v("Logout")])])}
var staticRenderFns = []

export { render, staticRenderFns }